import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import types from './types';

const initialState = {
  allDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  pendingReviewDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  expiredDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  archivedDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  trashDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  filtersDropdown: {
    loading: false,
    data: {},
    error: '',
  },
  filterTypes: {
    loading: false,
    data: {},
    error: '',
  },
  filterSources: {
    loading: false,
    data: [],
    error: '',
  },
  storage: {
    loading: false,
    data: {},
    error: '',
  },
  productAllFiles: {
    loading: false,
    data: {},
    error: '',
  },
  productArchivedFiles: {
    loading: false,
    data: {},
    error: '',
  },
  createProductFolder: {
    loading: false,
    data: {},
    error: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(types.GET_ALL_DOCUMENTS): {
      return {
        ...state,
        allDocuments: {
          ...state.allDocuments,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_ALL_DOCUMENTS): {
      return {
        ...state,
        allDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_ALL_DOCUMENTS): {
      return {
        ...state,
        allDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_PENDING_REVIEW_DOCUMENTS): {
      return {
        ...state,
        pendingReviewDocuments: {
          ...state.pendingReviewDocuments,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_PENDING_REVIEW_DOCUMENTS): {
      return {
        ...state,
        pendingReviewDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_PENDING_REVIEW_DOCUMENTS): {
      return {
        ...state,
        pendingReviewDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_EXPIRED_DOCUMENTS): {
      return {
        ...state,
        expiredDocuments: {
          ...state.expiredDocuments,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_EXPIRED_DOCUMENTS): {
      return {
        ...state,
        expiredDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_EXPIRED_DOCUMENTS): {
      return {
        ...state,
        expiredDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_ARCHIVED_DOCUMENTS): {
      return {
        ...state,
        archivedDocuments: {
          ...state.archivedDocuments,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_ARCHIVED_DOCUMENTS): {
      return {
        ...state,
        archivedDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_ARCHIVED_DOCUMENTS): {
      return {
        ...state,
        archivedDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_TRASH_DOCUMENTS): {
      return {
        ...state,
        trashDocuments: {
          ...state.trashDocuments,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_TRASH_DOCUMENTS): {
      return {
        ...state,
        trashDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_TRASH_DOCUMENTS): {
      return {
        ...state,
        trashDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN): {
      return {
        ...state,
        filtersDropdown: {
          ...state.filtersDropdown,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN): {
      return {
        ...state,
        filtersDropdown: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN): {
      return {
        ...state,
        filtersDropdown: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DOCUMENT_MANAGEMENT_FILTER_TYPES): {
      return {
        ...state,
        filterTypes: {
          ...state.filterTypes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DOCUMENT_MANAGEMENT_FILTER_TYPES): {
      return {
        ...state,
        filterTypes: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DOCUMENT_MANAGEMENT_FILTER_TYPES): {
      return {
        ...state,
        filterTypes: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES): {
      return {
        ...state,
        filterSources: {
          ...state.filterSources,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES): {
      return {
        ...state,
        filterSources: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES): {
      return {
        ...state,
        filterSources: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DOCUMENT_MANAGEMENT_STORAGE): {
      return {
        ...state,
        storage: {
          ...state.storage,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DOCUMENT_MANAGEMENT_STORAGE): {
      return {
        ...state,
        storage: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DOCUMENT_MANAGEMENT_STORAGE): {
      return {
        ...state,
        storage: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_PRODUCT_ALL_FILES): {
      return {
        ...state,
        productAllFiles: {
          ...state.productAllFiles,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_PRODUCT_ALL_FILES): {
      return {
        ...state,
        productAllFiles: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_PRODUCT_ALL_FILES): {
      return {
        ...state,
        productAllFiles: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_PRODUCT_ARCHIVED_FILES): {
      return {
        ...state,
        productArchivedFiles: {
          ...state.productArchivedFiles,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_PRODUCT_ARCHIVED_FILES): {
      return {
        ...state,
        productArchivedFiles: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_PRODUCT_ARCHIVED_FILES): {
      return {
        ...state,
        productArchivedFiles: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.CREATE_PRODUCT_FOLDER): {
      return {
        ...state,
        createProductFolder: {
          ...state.createProductFolder,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.CREATE_PRODUCT_FOLDER): {
      return {
        ...state,
        createProductFolder: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.CREATE_PRODUCT_FOLDER): {
      return {
        ...state,
        createProductFolder: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    default:
      return state;
  }
};
